export var IconButtonSkins;
(function (IconButtonSkins) {
    IconButtonSkins["Line"] = "line";
    IconButtonSkins["Full"] = "full";
})(IconButtonSkins || (IconButtonSkins = {}));
export var IconButtonThemes;
(function (IconButtonThemes) {
    IconButtonThemes["None"] = "none";
    IconButtonThemes["Box"] = "box";
})(IconButtonThemes || (IconButtonThemes = {}));
//# sourceMappingURL=types.js.map